import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { Link } from 'gatsby';
import '../utils/normalize.css';
import '../utils/css/screen.css';
import styled, { keyframes } from 'styled-components';
import { headShake, bounceInRight } from 'react-animations';
import Layout from '../components/layout';
import SEO from '../components/seo';
import Helmet from 'react-helmet';
// import Bio from "../components/bio";
import PostCard from '../components/postCard';

import { Icon, InlineIcon } from '@iconify/react';
import pythonIcon from '@iconify/icons-cib/python';
import djangoIcon from '@iconify/icons-cib/django';
import reactIcon from '@iconify/icons-cib/react';
import gatsbyIcon from '@iconify/icons-cib/gatsby';
import fiverrIcon from '@iconify/icons-simple-icons/fiverr';
import freelancerIcon from '@iconify/icons-simple-icons/freelancer';
import googleDevelopersIcon from '@iconify/icons-logos/google-developers-icon';
import acmIcon from '@iconify/icons-cib/acm';
import ScrollAnimation from 'react-animate-on-scroll';
// import "../utils/global.scss";
import AwesomeSlider from 'react-awesome-slider';
import AwesomeSliderStyles from 'react-awesome-slider/src/styled/fold-out-animation';

// import "semantic-ui-css/semantic.min.css";
import GatsbyImage from 'gatsby-image';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { format } from "prettier";
import 'animate.css/animate.min.css';
// const fiverLogo = require("./../icons/fiverr.png");
const nucesLogo = require('./../icons/nuces.png');
const cernLogo = require('./../icons/cern.png');
// const retrocausalLogo = require('./../icons/retrocausal-trans-logo.png');
// const djangoLogo = require("./../icons/django.ico");
// const reactLogo = require("./../icons/react.ico");
// const pythonLogo = require("./../icons/python.png");
// const javascriptLogo = require("./../icons/javascript.png");

//TODO: switch to staticQuery, get rid of comments, remove unnecessary components, export as draft template
const BlogIndex = ({ data }, location) => {
  const siteTitle = data.site.siteMetadata.title;
  const posts = data.allFile.nodes;
  const HeadShake = styled.div`
    animation: 2s ${keyframes`${headShake}`};
  `;
  const Bounce = styled.div`
    animation: 2s ${keyframes`${bounceInRight}`};
  `;
  let postCounter = 0;
  // console.log(data);
  return (
    <Layout title={siteTitle}>
      <Helmet>
        <script src="https://profile.codersrank.io/widget/widget.js"></script>
      </Helmet>
      <SEO
        title="Home"
        keywords={[
          'python',
          'developer',
          'AI',
          'machine learning',
          'ml',
          `devlog`,
          `blog`,
          `gatsby`,
          `javascript`,
          `react`,
          'hassan',
          'hassan11196',
          'hassanahmed19',
          'hassan fast',
          'hassan ahmed',
          '11196'
        ]}
      />

      {/* <Bio /> */}
      {data.site.siteMetadata.description && (
        <header className="page-head" style={{ padding: `2vw 0` }}>
          <h2 className="page-head-title">
            <p>{data.site.siteMetadata.description}</p>
          </h2>
          <div className="row">
            <div className="col">
              <div
                style={{
                  padding: '1rem 0',
                  textAlign: 'center'
                }}
              >
                {' '}
                <HeadShake>
                  <Icon
                    color="white"
                    width="40x"
                    length="40x"
                    height="40x"
                    icon={pythonIcon}
                  ></Icon>
                </HeadShake>
              </div>
            </div>
            <div className="col">
              <div
                style={{
                  padding: '1rem 0',
                  textAlign: 'center'
                }}
              >
                <HeadShake>
                  <Icon
                    color="white"
                    width="40x"
                    length="40x"
                    height="40x"
                    icon={djangoIcon}
                  ></Icon>
                </HeadShake>
              </div>
            </div>
            <div className="col">
              <div
                style={{
                  padding: '1rem 0',
                  textAlign: 'center'
                }}
              >
                <HeadShake>
                  <Icon
                    color="white"
                    width="40x"
                    length="40x"
                    height="40x"
                    icon={reactIcon}
                  ></Icon>
                </HeadShake>
              </div>
            </div>
            <div className="col">
              <div
                style={{
                  padding: '1rem 0',
                  textAlign: 'center'
                }}
              >
                {' '}
                <HeadShake>
                  <Icon
                    color="white"
                    width="40x"
                    length="40x"
                    height="40x"
                    icon={gatsbyIcon}
                  ></Icon>
                </HeadShake>
              </div>
            </div>
          </div>
        </header>
      )}
      <hr />
      <codersrank-widget
        username="hassan11196"
        layout="horizontal"
        badges="3"
        Style="--bg-color: #111; --header-bg-color: #222; --badge-bg-color: #333; --badge-text-color: #fff;"
      ></codersrank-widget>
      <hr />
      {data.site.siteMetadata.description && (
        <>
          <div className="row">
            <div className="col-2">
              <ScrollAnimation animateIn="bounceInRight">
                <GatsbyImage
                  width="60x"
                  height="60x"
                  fluid={data.cernLogo.nodes[0].childImageSharp.fluid}
                ></GatsbyImage>
              </ScrollAnimation>
            </div>
            <div className="col-10">
              <h3>Software Engineer at CERN, CMS Offline and Computing(O&C) </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-2">
              <ScrollAnimation animateIn="bounceInRight">
                <GatsbyImage
                  width="120x"
                  height="60x"
                  fluid={data.retroLogo.nodes[0].childImageSharp.fluid}
                ></GatsbyImage>
              </ScrollAnimation>
            </div>
            <div className="col-10">
              <h3>Computer Vision Research Engineer at Retrocausal AI</h3>
            </div>
          </div>
          <div className="row">
            <div className="col-2">
              <ScrollAnimation animateIn="bounceInRight">
                <GatsbyImage
                  width="60x"
                  height="60x"
                  fluid={data.cernLogo.nodes[0].childImageSharp.fluid}
                ></GatsbyImage>
              </ScrollAnimation>
            </div>
            <div className="col-10">
              <h3>Summer intern at CERN OpenLab. </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-2">
              <ScrollAnimation animateIn="bounceInRight">
                <GatsbyImage
                  width="70x"
                  height="70x"
                  fluid={data.nucesLogo.nodes[0].childImageSharp.fluid}
                ></GatsbyImage>
              </ScrollAnimation>
            </div>
            <div className="col-10">
              <h3>Teaching Assistant at FAST NUCES Karachi. </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-2">
              <ScrollAnimation animateIn="bounceInRight">
                <InlineIcon
                  box={true}
                  width="90%"
                  length="90%"
                  icon={acmIcon}
                ></InlineIcon>
              </ScrollAnimation>
            </div>
            <div className="col-10">
              <h3>Head Web Development for ACM NUCES Karachi Chapter. </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-2">
              <ScrollAnimation animateIn="bounceInRight">
                <InlineIcon
                  box={true}
                  width="90%"
                  length="90%"
                  icon={googleDevelopersIcon}
                ></InlineIcon>
              </ScrollAnimation>
            </div>
            <div className="col-10">
              <h3>
                Co-Lead Web Development for Google Developer Student Club - DSC
                NUCES.{' '}
              </h3>
            </div>
          </div>
        </>
      )}
      {/* <AwesomeSlider animation="foldOutAnimation" cssModule={AwesomeSliderStyles}>
       
          {data.slides.nodes.map((slide)=>{
          return (
            <article
            className={`kg-card kg-image-card`}
          
          >
            <Img fluid={
              slide.childImageSharp.fluid
            }
            objectFit="cover"
            objectPosition="50% 50%"
            alt="This is a picture of my face."
            >
            </Img>
            <h1>
              My Name is M.Hassan Ahmed
          </h1>
          </article>
          )})
        }
        
      </AwesomeSlider> */}
      <hr />
      <h2
        id="page-head-title"
        style={{
          padding: '1rem 0',
          textAlign: 'center'
        }}
      >
        Projects
      </h2>
      <div className="post-feed">
        {posts.map(node => {
          postCounter++;
          // console.log(node);
          if (node.sourceInstanceName === 'blog') {
            return;
          }
          return (
            <PostCard
              key={node.children[0].fields.slug}
              count={postCounter}
              node={node.children[0]}
              sourceInstanceName={node.sourceInstanceName}
              postClass={`post`}
            />
          );
        })}
      </div>
      <hr />
      {data.site.siteMetadata.description && (
        <h2
          className="page-head-title"
          style={{
            padding: '1rem 0',
            textAlign: 'center'
          }}
        >
          I am also a Freelancer at{' '}
          <a
            title="Fiverr"
            target="_blank"
            href={data.site.siteMetadata.social.fiverr}
          >
            <Icon icon={fiverrIcon} /> Fiverr
          </a>{' '}
          and{' '}
          <a
            title="Freelancer"
            target="_blank"
            href={data.site.siteMetadata.social.freelancer}
          >
            <Icon icon={freelancerIcon} />
            Freelancer
          </a>
          .
        </h2>
      )}
    </Layout>
  );
};

const indexQuery = graphql`
  query {
    nucesLogo: allFile(
      limit: 100
      filter: { sourceInstanceName: { eq: "assets" }, name: { eq: "nuces" } }
    ) {
      totalCount
      nodes {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid
          }
        }
        name
      }
    }
    cernLogo: allFile(
      limit: 100
      filter: {
        sourceInstanceName: { eq: "assets" }
        name: { eq: "cern-logo-trans" }
      }
    ) {
      totalCount
      nodes {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid
          }
        }
        name
      }
    }
    retroLogo: allFile(
      limit: 100
      filter: {
        sourceInstanceName: { eq: "assets" }
        name: { eq: "retro-log-cropped" }
      }
    ) {
      totalCount
      nodes {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid
          }
        }
        name
      }
    }
    slides: allFile(
      limit: 100
      filter: { sourceInstanceName: { eq: "home-slides" } }
    ) {
      totalCount
      nodes {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
    site {
      siteMetadata {
        title
        description
        social {
          fiverr
          freelancer
        }
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date
            title
            description
            tags

            thumbnail {
              childImageSharp {
                fluid(maxWidth: 1360) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
    allFile(
      filter: { ext: { eq: ".md" } }
      limit: 100
      sort: { fields: modifiedTime, order: DESC }
    ) {
      nodes {
        id
        children {
          id
          ... on MarkdownRemark {
            id
            fields {
              slug
            }
            frontmatter {
              title
              date
              description
              tags
              thumbnail {
                childImageSharp {
                  fluid(maxWidth: 1360) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
        relativePath
        relativeDirectory
        ext
        sourceInstanceName
      }
    }
  }
`;
export default props => (
  <StaticQuery
    query={indexQuery}
    render={data => (
      <BlogIndex location={props.location} props data={data} {...props} />
    )}
  />
);
